<template>
  <validation-observer
    v-slot="{ errors }"
    ref="tags"
    tag="div"
    class="w-100"
  >
    <div class="d-flex tags-header">
      <label
        class="w-100"
        :class="newerVersions ? '' : 'mr-1'"
      >Choose storage class transitions</label>
      <label class="w-100">Number of days</label>
      <label
        v-if="newerVersions"
        class="w-100"
      >Number of newer versions</label>
    </div>
    <template v-for="tag in tags">
      <div
        :key="tag.index"
        class="d-flex align-items-center position-relative mb-1"
      >
        <custom-select
          :id="`key${tag.index}`"
          v-model="tag.rule"
          :options="options"
          :selectable="option => option.selectable"
          class="mr-1"
        />
        <validation-provider
          #default="{ errors }"
          :vid="`value${tag.index}`"
          name="Days"
          rules="required|minValueRule:30"
          tag="div"
          class="w-100"
        >
          <b-input
            :id="`value${tag.index}`"
            v-model="tag.days"
            type="number"
            :state="errors.length > 0 ? false : null"
            placeholder="Days"
            class="mb-0 mr-0"
          />
        </validation-provider>
        <b-input
          v-if="newerVersions"
          v-model="tag.versions"
          type="number"
          placeholder="Versions"
          class="w-100 ml-1 mb-0 mr-0"
        />
        <!-- <a
          class="right-icon"
          @click="onRemoveField(tag.index)"
        >
          <GjIcon name="Delete" />
        </a> -->
      </div>
      <div
        v-if="
          errors[`value${tag.index}`] && errors[`value${tag.index}`].length > 0
        "
        :key="`error${tag.index}`"
      >
        <small class="text-danger">{{ errors[`value${tag.index}`][0] }}</small>
      </div>
    </template>
    <!-- <div
      class="px-1 px-md-2"
      :class="{ 'mt-1': tags.length > 0 }"
    >
      <a
        class="text-primary text-medium"
        @click="onAddField"
      >
        + Add
      </a>
    </div> -->
  </validation-observer>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required, minValueRule } from '@validations'

export default {
  name: 'LifecycleTags',
  components: { ValidationObserver, ValidationProvider },
  props: {
    tags: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    newerVersions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      minValueRule,
    }
  },
  computed: {
    lastIndex() {
      return this.tags.length ? this.tags[this.tags.length - 1].index : 0
    },
  },
  methods: {
    onAddField() {
      this.tags.push({
        index: this.lastIndex + 1,
        rule: 0,
        days: null,
        versions: null,
      })
    },
    onRemoveField(index) {
      this.tags = this.tags.filter(obj => obj.index !== index)
    },
  },
}
</script>
<style lang="scss" scoped>
.right-icon {
  margin-left: 10px;
  &.absolute {
    position: absolute;
    left: 100%;
  }
}
.custom-width {
  width: calc(50% - 2rem);
  margin-left: 2rem;
  @media (max-width: 767.8px) {
    width: calc(50% - 1rem);
    margin-left: 1rem;
  }
}
</style>
